// import React, { useState } from "react";
// import { Dropdown, Menu, Modal, Button } from "antd";

// const videos = [
// ];

// function VideoDropdownModal() {
//   const [selectedVideo, setSelectedVideo] = useState(null);
//   const [isModalVisible, setIsModalVisible] = useState(false);

//   const handleMenuClick = ({ key }) => {
//     const video = videos[key];
//     setSelectedVideo(video);
//     setIsModalVisible(true);
//   };

//   const menu = (
//     <Menu onClick={handleMenuClick}>
//       {videos.map((video, index) => (
//         <Menu.Item key={index}>{video.title}</Menu.Item>
//       ))}
//     </Menu>
//   );

//   return (
//     <div >
//       <Dropdown overlay={menu} trigger={['click']}>
//         <Button className="button">
//           Videoni tanlang
//         </Button>
//       </Dropdown>

//       <Modal
//         open={isModalVisible}
//         title={selectedVideo?.title}
//         footer={null}
//         onCancel={() => setIsModalVisible(false)}
//         destroyOnClose
//       >
//         {selectedVideo && (
//           <video width="100%" controls autoPlay>
//             <source src={selectedVideo.src} type="video/mp4" />
//           </video>
//         )}
//       </Modal>
//     </div>
//   );
// }

// export default VideoDropdownModal;


import React, { useState } from "react";
import { Button, Modal } from "antd";

const YouTubeDropdown = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const videos = [
    { id: "7KNI4Wk0BNY", title: "1-video" },
    { id: "j8uk7tmP3aM", title: "2-video" },
    { id: "OKTnmhwlCnM", title: "3-video" },
    { id: "1HDyaCtd99g", title: "4-video" },
    { id: "GmbrX0_L8dU", title: "5-video" },
    { id: "hUbgty8mcmw", title: "6-video" },
    { id: "-YwKNT8srv4", title: "7-video" },
  ];

  return (
    <>
      <Button className="button" onClick={showModal}>
        Videolar
      </Button>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        title="YouTube Videolar"
      >
        {videos.map((video) => (
          <a
            key={video.id}
            href={`https://www.youtube.com/watch?v=${video.id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", alignItems: "center", color: "black", marginBottom: "10px" }}
          >
            <img 
            className="alt"
              src={`https://img.youtube.com/vi/${video.id}/default.jpg`}
              alt={video.title}
              style={{ width: "50px", marginRight: "10px" }}
            />
            {video.title}
          </a>
        ))}
      </Modal>
    </>
  );
};

export default YouTubeDropdown;
